<!--
/*******************************************************************************
*@ 컴포넌트명   : NewsComponent.vue
*@ 컴포넌트설명 : 공지/새소식 컴포넌트
*@ 사용전문     : 
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <div v-if="totalCnt > 0">
    <div class="total-count">{{ /*총 건수*/ $t("MCOM-0000079") }} : {{ totalCnt }}</div>
    <ul class="ulist" v-for="(list, i) of newsList" :key="i">
      <li class="item" @click="goToDetail(list)">
        <span class="tit" v-if="lang === 'KOR'">{{ list.hanglTitlCtnt }}</span>
        <span class="tit" v-else-if="lang === 'ENG'">{{ list.engTitlCtnt }}</span>
        <span class="tit" v-else v-html="list.lcalTitlCtnt"></span>
        <div class="dec">
          <span class="date">{{ $getGlobalDateFmt(list.regiYMS.substring(0, 8)) }}</span>
          <i v-if="lang === 'KOR' && !_.isEmpty(list.hangFileList)" class="icon icon-download-sm" />
          <i v-if="lang === 'ENG' && !_.isEmpty(list.engFileList)" class="icon icon-download-sm" />
          <i v-if="lang === 'LOC' && !_.isEmpty(list.lcalFileList)" class="icon icon-download-sm" />
        </div>
        <i class="icon icon-arrow-m-right" />
      </li>
    </ul>
  </div>
  <div v-else class="empty">
    <div class="empty-img">
      <i class="icon icon-opt-no" />
    </div>
    <strong class="empty-text">{{ /*조회 내역이 없습니다.*/ $t("MCOM-0000015") }}</strong>
  </div>
</template>
<script>
import { mapFields } from "vuex-map-fields";
import { unWatchStore, unWatchHook, watchBoardList } from "@/mixins/basicComponent";
export default {
  mixins: [unWatchStore, unWatchHook, watchBoardList],
  computed: {
    ...mapFields(["lang", "siteCode", "menuTitle"]),
  },
  props: {
    operGroupCd: { type: String, required: true },
  },
  mounted() {
    this.firstCall();
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  data() {
    return {
      page: 1,
      totalCnt: "", //총 건수
      newsList: [], //공지/새소식 목록
    };
  },
  methods: {
    firstCall() {
      this.page = 1;
      this.noticeCall(this.page);
    },
    noticeCall(page) {
      if (page == null) {
        this.page++;
      } else {
        this.page = 1;
      }
      this.requestData = {
        boardID: this.$route.name == "mmrFinancialStatements" ? "020" : "001",
        displayCnt: "10",
        dmndCnt: this.page,
        operGroupCd: this.operGroupCd,
      };
      //공지사항 FAQ 서식약관 리스트 조회 API 호출
      this.$post("/commonbiz/board/listsearch", this.requestData, this.noticeSuc);
    },
    noticeSuc(res) {
      this.totalCnt = res.outItem.totalCnt;

      if (this.page === 1) {
        this.newsList = [
          //공지/새소식 호출 결과
          ...res.outItem.boardList,
        ];
      } else {
        this.newsList = [...this.newsList, ...res.outItem.boardList];
      }
    },
    goToDetail(list) {
      if (this.$route.name == "mmrFinancialStatements") {
        this.$router.push({
          name: "mmrFinancialStatementsDetail",
          params: { serNo: list.bltcSerno, operGroupCd: this.operGroupCd },
        });
      } else {
        this.$router.push({
          name: "newsDetail",
          params: { serNo: list.bltcSerno, operGroupCd: this.operGroupCd },
        });
      }
    },
    handleScroll() {
      let scrollHeight = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight);
      let scrollTop = Math.max(document.documentElement.scrollTop, document.body.scrollTop);
      let clientHeight = document.documentElement.clientHeight;

      if (scrollTop + clientHeight >= scrollHeight - 30 && this.page * 10 < this.totalCnt) {
        this.noticeCall();
      }
    },
  },
};
</script>
